<ul class="{{ ulClasses() }}">
    @for (option of options(); track $index) {
    <li
        class="{{ liClasses() }}"
        [ngClass]="{
            selected: option === selectedOption()
        }"
        (click)="onClickOption(option)"
    >
        <ng-container *ngTemplateOutlet="optionTemplate(); context: { option: option }">
        </ng-container>
    </li>
    }
</ul>
